<template>
  <div
    v-if="
      activeTags.length
    "
    class="filter-tags">
    <el-tag
      v-for="
        tag in visibleTags
      "
      :key="
        tag
      "
      type="sc-asset"
      :closable="
        tag !== 'date' && !disabled
      "
      :class="{
        'tag-disabled': disabled
      }"
      @click="
        () => clickTag(tag)
      "
      @close="
        () => removeTag(tag)
      ">
      {{ label(tag) }}
    </el-tag>
    <el-tag
      v-if="
        hasOverflow
      "
      type="sc-asset"
      :closable="false"
      :class="{
        'tag-disabled': disabled
      }"
      @click="
        () => clickTag(null)
      ">
      อื่นๆ ({{ overflowCount }})
    </el-tag>
  </div>
</template>

<script lang="js">

// Libs
import { DateTime } from 'luxon'

// Common
import { SubsReportCommon as Common } from '@/features/subscribers-report/common/subs-report.common'
import { SubsReportFilterCommon as FilterCommon } from '@/features/subscribers-report/common/subs-report-filter.common'

// Filter common
const { filter } = FilterCommon

export default {
  props: {
    filter: {
      type   : Object,
      default: () => filter()
    },
    disabled: {
      type   : Boolean,
      default: false
    },
    max: {
      type   : Number,
      default: 2
    },
  },
  data() {
    return {
      form: filter(),
      tags: [
        'dateType',
        'date',
        'groupName',
        'pkg',
        'status',
        'seller',
        'receipt',
        'usedCoin',
        'docs'
      ]
    }
  },
  computed: {
    activeTags() {
      return (
        this.tags.filter(
          (tag) => this.isActive(tag)
        )
      )
    },
    visibleTags() {
      return (
        this.max ? this.activeTags.slice(0, this.max) : this.activeTags
      )
    },
    overflowCount() {
      return (
        this.max ? this.activeTags.length - this.max : 0
      )
    },
    hasOverflow() {
      return (
        this.overflowCount > 0
      )
    },
  },
  watch: {
    filter(value) {
      this.form = Object.assign(
        filter(), value
      )
    }
  },
  created() {
    this.form = Object.assign(
      filter(), this.filter
    )
  },
  methods: {
    isActive(key) {

      // Form props
      const { dateStart, dateStop, docs } = this.form

      switch (key) {

        // Date range
        case 'date': {
          return (
            !!(dateStart && dateStop) && !(docs && docs.length)
          )
        }

        // Docs
        case 'docs': {
          return (
            !!(docs && docs.length)
          )
        }

        // Dropdown options
        default: {
          return !!this.form[key]
        }
      }
    },
    label(key) {

      // Form props
      const { dateStart, dateStop, docs } = this.form

      switch (key) {

        // Date range
        case 'date': {
          
          // Format date
          const start = this.formatDate(dateStart)
          const stop = this.formatDate(dateStop)

          return (
            start === stop ? start : `${start} - ${stop}`
          )
        }

        // Used coin
        case 'usedCoin': {
          return 'เฉพาะที่ใช้ MNC'
        }

        // Docs
        case 'docs': {
          return `เลขที่เอกสาร (${docs.length})`
        }

        // Date type
        case 'dateType': {
          return this.findLabel(
            Common.dateType, this.form.dateType
          )
        }

        // Group name
        case 'groupName': {
          return this.findLabel(
            Common.groupName, this.form.groupName
          )
        }

        // Package
        case 'pkg': {
          return this.findLabel(
            Common.pkg, this.form.pkg
          )
        }

        // Status
        case 'status': {
          return this.findLabel(
            Common.status, this.form.status
          )
        }

        // Seller
        case 'seller': {
          return this.findLabel(
            Common.seller, this.form.seller
          )
        }

        // Receipt
        case 'receipt': {
          return this.findLabel(
            Common.receipt, this.form.receipt
          )
        }

        default:
          return null
      }
    },
    clickTag(key) {
      
      // Validate diabled
      if (this.disabled) return
      
      // Emit event
      this.$emit(
        'click', key
      )
    },
    removeTag(key) {
      if (this.disabled) return

      this.$emit(
        'remove', key
      )
    },
    findLabel(options, value) {

      // Find label
      const option = options.find(
        (item) => item.value === value
      )

      return (
        option && option.label
      )
    },
    formatDate(date) {

      // Validate date
      if (!date) return null

      // Date format
      const format = 'yyyy/MM/dd'

      return (
        DateTime.fromJSDate(new Date(date)).toFormat(format)
      )
    }
  }
}

</script>

<style lang="css" scoped>

.filter-tags {
  display   : flex;
  flex-wrap : wrap;
  gap       : var(--size-xs);
}

.el-tag {
  font-size  : .8rem;
  font-weight: bold;
  cursor     : pointer;
}

.filter-tags .el-tag.tag-clear {
  color           : #909399;
  background-color: #f0f0f1;
}

.el-tag.tag-disabled {
  cursor        : not-allowed;
  opacity       : .6;
  pointer-events: none;
}

</style>
